import React from 'react';
import { 
  FiDollarSign, 
  FiShield, 
  FiCheckCircle, 
  FiTool, 
  FiTruck,
  FiCrosshair,
  FiZap
} from 'react-icons/fi';
import './Services.css';

const servicesData = [
  {
    icon: FiDollarSign,
    title: 'Free Estimates',
    description: 'Get a detailed, no-obligation estimate for your repair needs quickly and easily.'
  },
  {
    icon: FiShield,
    title: 'Insurance Assistance',
    description: 'We work directly with your insurance company to streamline the claims process.'
  },
  {
    icon: FiCheckCircle,
    title: 'Lifetime Warranty',
    description: 'All our repairs are backed by a comprehensive lifetime warranty for your peace of mind.'
  },
  {
    icon: FiTool,
    title: 'Full Service Mechanical',
    description: 'Complete mechanical repairs and maintenance services to keep your vehicle running perfectly.'
  },
  {
    icon: FiTruck,
    title: 'Towing Services',
    description: 'Convenient towing services available to bring your vehicle directly to our facility.'
  },
  {
    icon: FiCrosshair,
    title: 'Automotive Glass',
    description: 'Professional windshield and automotive glass replacement with precision installation.'
  },
  {
    icon: FiZap,
    title: 'Paintless Dent Repair',
    description: 'Advanced paintless dent removal techniques that preserve your original factory finish.'
  }
];

const Services = () => {
  return (
    <section id="services" className="services section">
      <div className="container">
        <div className="services__header">
          <h2 className="services__title">Our Services</h2>
          <p className="services__subtitle">
            Comprehensive collision repair and automotive services to meet all your needs
          </p>
        </div>
        <div className="services__grid">
          {servicesData.map((service, index) => (
            <div key={index} className="service-card">
              <div className="service-card__icon" aria-hidden="true">
                <service.icon />
              </div>
              <h3 className="service-card__title">{service.title}</h3>
              <p className="service-card__description">{service.description}</p>
              <a href="tel:+18326156065" className="service-card__cta">Get Estimate →</a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
